var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManpowerLogo25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg3498",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 666.4 615.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #252525;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3522",
    className: "st0",
    d: "M546,227.1c-5.9,16.3-23.9,24.7-40.2,18.7-16.2-5.9-24.6-23.9-18.7-40.2l55.3-152c5.9-16.3,23.9-24.6,40.2-18.7,16.3,5.9,24.7,23.9,18.7,40.2l-55.3,152h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g3524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3526",
    className: "st0",
    d: "M120.5,325.5c-5.9,16.3-23.9,24.6-40.2,18.7-16.3-5.9-24.7-23.9-18.7-40.2l63.3-173.8c5.9-16.3,23.9-24.7,40.2-18.7,16.3,5.9,24.7,23.9,18.7,40.2l-63.3,173.8Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g3528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3530",
    className: "st0",
    d: "M217.9,325.5c-5.9,16.3-23.9,24.6-40.2,18.7-16.3-5.9-24.7-23.9-18.7-40.2l63.3-173.8c5.9-16.3,23.9-24.7,40.2-18.7,16.3,5.9,24.7,23.9,18.7,40.2l-63.3,173.8Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g3532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3534",
    className: "st0",
    d: "M315.3,325.5c-5.9,16.3-23.9,24.6-40.2,18.7-16.3-5.9-24.7-23.9-18.7-40.2l63.3-173.8c5.9-16.3,23.9-24.7,40.2-18.7,16.3,5.9,24.7,23.9,18.7,40.2l-63.3,173.8Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g3536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3538",
    className: "st0",
    d: "M412.6,325.5c-5.9,16.3-23.9,24.6-40.2,18.7-16.3-5.9-24.7-23.9-18.7-40.2l91.1-250.4c5.9-16.3,23.9-24.6,40.2-18.7,16.3,5.9,24.7,23.9,18.7,40.2l-91.1,250.4h0Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g3540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3542",
    className: "st0",
    d: "M5.6,457.7h17.8l30.8,82.1,30.9-82.1h17.8v97.7h-12.3v-81.3h-.3l-30.5,81.3h-11.1l-30.5-81.3h-.3v81.3H5.6s0-97.7,0-97.7Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g3544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3546",
    className: "st0",
    d: "M164.6,518.9c-4.5,3.3-13.3,3.4-21.1,4.8-7.7,1.4-14.2,4.1-14.2,12.7s6.6,10.4,13.7,10.4c15.3,0,21.6-9.6,21.6-16v-11.9h0ZM183.5,555.2c-2.1,1.2-4.7,1.9-8.3,1.9-6,0-9.8-3.3-9.8-10.9-6.4,7.5-15.1,10.9-24.9,10.9s-23.4-5.7-23.4-19.8,11.9-19.4,23.9-21.7c12.9-2.5,23.8-1.6,23.8-10.4s-8.4-11.8-15.8-11.8-17.1,3-17.6,13.4h-11.6c.7-17.5,14.2-23.7,30-23.7s26.5,2.9,26.5,19.4v36.4c0,5.5,0,7.9,3.7,7.9s2-.1,3.6-.7v9h0Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "g3548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3550",
    className: "st0",
    d: "M194,484.7h11v11.2h.3c4.9-8.8,12.9-12.9,23-12.9,18.6,0,24.4,10.7,24.4,25.9v46.5h-11.6v-47.9c0-8.6-5.5-14.3-14.4-14.3-14.1,0-20.9,9.5-20.9,22.2v40h-11.6v-70.7h0Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g3552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3554",
    className: "st0",
    d: "M300.6,493.3c-15.6,0-21.6,13.4-21.6,26.7s6.3,26.8,22.3,26.8,21.2-13.5,21.2-27.4-6.8-26.1-21.9-26.1M267.8,484.7h11.6v9.6h.3c3.8-7.8,12.9-11.2,22.6-11.2,21.8,0,32.6,17.2,32.6,37.2s-10.7,36.8-32.3,36.8-17.6-2.7-22.8-11.1h-.3v36.5h-11.6v-97.8h0Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "g3556"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3558",
    className: "st0",
    d: "M378.2,546.8c12.2,0,22-9.6,22-26.7s-9.8-26.8-22-26.8-22,9.6-22,26.8,9.9,26.7,22,26.7M378.2,483c22.4,0,34.4,16.3,34.4,37.1s-11.9,36.9-34.4,36.9-34.3-16.3-34.3-36.9,11.9-37.1,34.3-37.1"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g3560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3562",
    className: "st0",
    d: "M492.7,555.4h-12.3l-14.4-56.2h-.3l-14.2,56.2h-12.6l-22.7-70.7h12.9l16,57.9h.3l14.2-57.9h12.7l14.8,57.9h.3l15.9-57.9h12.1l-22.6,70.7Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "g3564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3566",
    className: "st0",
    d: "M571.4,513.3c-.6-11.1-8.9-20-20.4-20s-19.4,9.2-20.3,20h40.6ZM582.6,533c-3.2,15.6-14.4,24.1-30.2,24.1-22.6,0-33.2-15.6-33.9-37.2,0-21.2,14-36.8,33.2-36.8s32.7,23.4,32,40.5h-53c-.4,12.3,6.6,23.3,22,23.3s16.3-4.6,18.3-13.8h11.5Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "g3568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3570",
    className: "st0",
    d: "M595.3,484.7h11v14.9h.3c5.6-11.4,13.4-17,26-16.6v12.3c-18.7,0-25.6,10.7-25.6,28.6v31.5h-11.6v-70.7h0Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "g3572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3574",
    className: "st0",
    d: "M647.6,467.8h2.1c1.8,0,3.4,0,3.4-2.1s-1.4-2-2.8-2h-2.6v4.1h0ZM645.6,462.2h4.9c3,0,4.5,1.2,4.5,3.7s-1.5,3.3-3.4,3.5l3.7,5.7h-2.1l-3.4-5.5h-2.1v5.5h-2v-12.8h0ZM649.9,477.9c5.1,0,9-4,9-9.4s-3.9-9.3-9-9.3-9,4.1-9,9.3,3.9,9.4,9,9.4M649.9,457.6c6,0,11,4.7,11,10.9s-5,11-11,11-11-4.7-11-11,5-10.9,11-10.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManpowerLogo25);
export default __webpack_public_path__ + "static/media/manpower-logo25.680bdbcb6563e119bbf455a29f8aad7c.svg";
export { ForwardRef as ReactComponent };